<template>
    <div :class="{ 'order-search-bar': true }">
      <div class="search-top-bar flex-col">
        <div class="search-bar-wrap flex-row">
          <div class="search-bar-left flex-col justify-between">
            <span class="text_10">{{$t('texts.waybillNo')}}</span>
            <el-input
              class="search-input"
              type="textarea"
              :autosize="{ minRows: 2, maxRows: 4 }"
              :placeholder="$t('placeholder.max50waybillNosAndSplit')"
              v-model="textareaText"
            ></el-input>
          </div>
          <div @click="searchFunc" class="search-btn flex-col">
            <div class="search-btn-icon flex-col"></div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script setup>
  import { ref } from 'vue';
  import { useRouter } from 'vue-router';
  import { $t } from "~/utils/index.js";
  // 响应式数据
  const textareaText = ref('');
  
  // 获取router实例
  const router = useRouter();
  
  // 搜索功能
  const searchFunc = () => {
    if (textareaText.value) {
      router.push(`/v?url=findOrder&searchStr=${textareaText.value}`);
    }
  };
  </script>
  
  <style scoped>
 
  .order-search-bar {
    /* Define any styles for the order-search-bar class */
  }
  
  .search-top-bar {
    box-shadow: 16px 36px 56px 0px rgba(0, 51, 102, 0.06);
    background-color: rgba(255, 255, 255, 1);
    border-radius: 16px;
    justify-content: center;
  }
  
  .search-bar-wrap {
    justify-content: space-between;
    background-color: rgba(255, 255, 255, 1);
    border-radius: 16px;
    height: 188px;
    border: 1px solid rgba(238, 238, 238, 1);
    margin: 28px;
  }
  
  .search-bar-left {
    flex: 1;
    margin: 49px 0 0 47px;
  }
  
  .text_10 {
    width: 96px;
    height: 45px;
    overflow-wrap: break-word;
    color: rgba(44, 46, 45, 1);
    font-size: 32px;
    font-family: PingFangHK-Semibold;
    text-align: left;
    white-space: nowrap;
    line-height: 45px;
  }
  
  .search-input {
    overflow-wrap: break-word;
    color: rgba(153, 153, 153, 1);
    font-size: 24px;
    font-family: PingFangHK-Regular;
    text-align: left;
    white-space: nowrap;
    line-height: 33px;
    margin-top: 10px;
  }
  
  .search-input :deep(.el-textarea__inner ){
    border: none;
    padding: 0;
    max-height: 50px;
    box-shadow: none;
  }
  
  .search-btn {
    background-color: rgba(44, 46, 45, 1);
    border-radius: 16px;
    height: 138px;
    width: 138px;
    margin: 24px 24px 0 0px;
    cursor: pointer;
  }
  
  .search-btn:hover {
    background: #000;
  }
  
  .search-btn-icon {
    width: 40px;
    height: 40px;
    background: url(~/assets/search-icon.png) 100% no-repeat;
    background-size: 100% 100%;
    margin: 49px 0 0 49px;
  }
  
  .search-history {
    height: 40px;
    margin: 0px 0 28px 75px;
  }
  
  .search-history-item {
    background-color: rgba(242, 242, 242, 1);
    border-radius: 16px 13px 13px 13px;
    padding: 5px 10px;
    height: 40px;
    margin-right: 10px;
    cursor: pointer;
  }
  
  .search-history-item-text {
    flex: 1;
    height: 28px;
    overflow-wrap: break-word;
    color: rgba(151, 161, 179, 1);
    font-size: 20px;
    font-family: PingFangHK-Semibold;
    text-align: left;
    white-space: nowrap;
    line-height: 28px;
  }
  
  .search-history-item-close {
    width: 18px;
    height: 18px;
    background: url(~/assets/close-gray-icon.png) 100% no-repeat;
    background-size: 100% 100%;
    margin-top: 5px;
    margin-left: 10px;
  }
  
  .block_6 {
    background-color: rgba(242, 242, 242, 1);
    border-radius: 16px 13px 13px 13px;
    width: 214px;
    height: 40px;
  }
  
  .image-text_2 {
    width: 194px;
    height: 28px;
    margin: 6px 0 0 11px;
  }
  
  .text-group_2 {
    width: 168px;
    height: 28px;
    overflow-wrap: break-word;
    color: rgba(151, 161, 179, 1);
    font-size: 20px;
    font-family: PingFangHK-Semibold;
    text-align: left;
    white-space: nowrap;
    line-height: 28px;
  }
  
  .group_5 {
    width: 18px;
    height: 18px;
    background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng10d21fcd829d916c9925cebcbf7ec1fb1acf8b39edb3f45398c6515397816e6d) 100% no-repeat;
    background-size: 100% 100%;
    margin-top: 5px;
  }
  
  .search-all-history {
    height: 40px;
    margin: 27px auto;
    width: 1400px;
  }
  
  .search-all-history .search-history {
    margin: 0;
  }
  
  .search-all-history-label {
    width: 120px;
    height: 33px;
    overflow-wrap: break-word;
    color: rgba(44, 46, 45, 1);
    font-size: 24px;
    font-family: PingFangHK-Semibold;
    text-align: left;
    white-space: nowrap;
    line-height: 33px;
    margin-top: 3px;
  }
  
  .group_6 {
    background-color: rgba(242, 242, 242, 1);
    border-radius: 16px 13px 13px 13px;
    width: 214px;
    height: 40px;
  }
  
  .image-text_3 {
    width: 194px;
    height: 28px;
    margin: 6px 0 0 11px;
  }
  
  .text-group_3 {
    width: 168px;
    height: 28px;
    overflow-wrap: break-word;
    color: rgba(151, 161, 179, 1);
    font-size: 20px;
    font-family: PingFangHK-Semibold;
    text-align: left;
    white-space: nowrap;
    line-height: 28px;
  }
  
  .section_8 {
    width: 18px;
    height: 18px;
    background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng10d21fcd829d916c9925cebcbf7ec1fb1acf8b39edb3f45398c6515397816e6d) 100% no-repeat;
    background-size: 100% 100%;
    margin-top: 5px;
  }
  </style>
  